import { useMutation, gql } from "@apollo/client"
import { LOCATION_FIELDS } from "./useQueryLocations"

const UPDATE_LOCATION_MUTATION = gql`
  ${LOCATION_FIELDS}
  mutation UpdateLocation($id: ID!, $name: String!, $timeZone: String!, $region: ID) {
    updateLocation(id: $id, name: $name, timeZone: $timeZone, region: $region) {
      ...LocationFields
    }
  }
`

const useMutationUpdateLocation = () => useMutation(UPDATE_LOCATION_MUTATION)

export { useMutationUpdateLocation }
